import { ENV } from '$env';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';
import { ViewProvider } from './view';

@Injectable()
export class ServerProvider {

  url = ENV.serverURL;

  private token: string;

  constructor(public http: HttpClient, public view: ViewProvider, private events: Events) {
    console.log('URL de Conexão: ' + this.url);
  }

  public setToken(token: string) {
    this.token = token;
  }

  public postData(data, background = false): Observable<any> {
    let loading: any;
    if (!background) {
      loading = this.view.showLoading();
    }

    console.debug(data);

    return Observable.create(observer => {
      if (data == null) {
        data = {};
      }

      if (this.token) {
        data.token = this.token;
      }

      let body = JSON.stringify(data);

      let headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json; charset=utf-8');

      let options = { headers: headers };

      this.http.post(this.url, body, options).subscribe(
        (success) => {
          let result: any;
          result = success;

          if (!background) {
            this.view.hideLoading(loading);
          }

          if (result.erro) {
            let msg = result.mensagem;
            if (result.codigo == '1001' && ENV.web) {
              msg = 'Ocorreu um erro de comunicação com o servidor. Caso o erro persista, atualize a página usando o atalho "ctrl + F5".';
            }
            this.view.showMessage(msg);
            observer.error(result.mensagem);
          } else {
            observer.next(success);
            observer.complete();
          }

        },

        (error) => {
          if (!background) {
            this.view.hideLoading(loading);
          }

          let status = error.status;
          console.log(`O servidor retornou o código de erro ${error.status}, e a mensagem de erro: ${error.message}`);

          if (status == 0) {
            this.view.showMessage("Não foi possível conectar com o servidor.");
            observer.complete();
            return;
          }

          if (status == 403) {
            this.events.publish("app:notSession");
            this.view.showToastError('Houve uma falha ao realizar operação, tente novamente');
            observer.error('Acesso negado ao serviço.');
          } else {
            this.view.showMessage(`O servidor retornou o código de erro ${error.status}`);
            observer.error('Erro de Conexão.');
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/server.ts